import * as React from 'react'
import {makeStyles} from '@material-ui/core'
import {observer} from 'mobx-react'
import {makeAutoObservable} from 'mobx'
import {Button} from 'devextreme-react/button'
import DateTimeService from '../Services/DateTimeService'
import { LNG } from '../Services/LanguageService';

type ConfirmationDialogProps = {
    key: string;
    title: string;
    resolve: (value: unknown) => void;
    message: string | JSX.Element;
    onConfirm?: () => void | Promise<void>;
};

const useStyles = makeStyles(theme => ({
    wrapper: {
        position: 'fixed',
        right: 0,
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 1500,
        display: 'flex',
        backgroundColor: 'rgba(0,0,0,.4)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dialog: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        overflow: 'hidden',
        borderRadius: theme.spacing(.5),
    },
    header: {
        borderBottom: '1px solid #eee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1, 2),
        fontSize: 18,
        fontWeight: 600,
    },
    content: {
        padding: theme.spacing(3),
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
    },
    footer: {
        padding: theme.spacing(1, 2),
        width: '100%',
        display: 'flex',
        borderTop: '1px solid #eee',
        justifyContent: 'space-between',
        flex: 0,
    },
}))

export const ConfirmationDialog = observer(() => {
    const classes = useStyles()
    const _onCancelClick = (key: string) => () => {
        confirmationStore.closeDialog(key)
    }
    return (
        <>
            {confirmationStore.modals.map(modal => {
                return (
                    <div className={classes.wrapper} key={modal.key}>
                        <div className={classes.dialog}>
                            <div className={classes.header}>{modal.title}</div>
                            <div className={classes.content}>{modal.message}</div>
                            <div className={classes.footer}>
                                <Button text={LNG.Text('Dashboard.78')} onClick={_onCancelClick(modal.key)} stylingMode="outlined"/>
                                <Button text={LNG.Text('Dashboard.172')} type="danger" onClick={confirmationStore.confirmDialog(modal.key)}
                                        stylingMode="outlined"/>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    )
})

class ConfirmationStore {
    public modals: ConfirmationDialogProps[] = []

    constructor() {
        makeAutoObservable(this)
    }

    public showConfirmation(message: string | JSX.Element, title: string) {
        return new Promise(resolve => {
            this.modals.push({message, title, key: `${DateTimeService.now().getTime()}`, resolve})
        })
    }

    public confirmDialog = (key?: string) => () => {
        if (this.modals.length) {
            let index = this.modals.findIndex(e => e.key === key)
            if (index === -1) {
                index = this.modals.length - 1
            }
            this.modals[index].resolve(true)
            this.closeDialog(this.modals[index].key)
        }
    }

    public closeDialog(key?: string) {
        if (this.modals.length) {
            let removeLast = true
            this.modals = this.modals.filter(e => {
                const isCurrent = e.key !== key
                if (isCurrent) removeLast = false
                return isCurrent
            })
            if (removeLast) {
                this.modals.pop()
            }
        }
    }
}

export const confirmationStore = new ConfirmationStore()